import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Form, Input, Select, Space, message, Popconfirm } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import axiosInstance from '../../../configs';

const CostTypeTable = () => {
    const [data, setData] = useState([]);
    const [groups, setGroups] = useState([]);
    const [loading, setLoading] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [editingId, setEditingId] = useState(null);
    const [form] = Form.useForm();

    const fetchData = async () => {
        setLoading(true);
        try {
            const [resTypes, resGroups] = await Promise.all([
                axiosInstance.get('/referensi-finance/types'),
                axiosInstance.get('/referensi-finance/groups')
            ]);
            setData(resTypes.data.data);
            setGroups(resGroups.data.data);
        } catch (err) {
            message.error('Gagal mengambil data');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handleAdd = () => {
        setEditingId(null);
        form.resetFields();
        setModalVisible(true);
    };

    const handleEdit = (record) => {
        setEditingId(record.id_type_cost);
        form.setFieldsValue(record);
        setModalVisible(true);
    };

    const handleDelete = async (id) => {
        try {
            await axiosInstance.delete(`/referensi-finance/types/${id}`);
            message.success('Jenis biaya berhasil dihapus');
            fetchData();
        } catch (err) {
            message.error(err.response?.data?.error || 'Gagal menghapus');
        }
    };

    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            if (editingId) {
                await axiosInstance.put(`/referensi-finance/types/${editingId}`, values);
                message.success('Berhasil diperbarui');
            } else {
                await axiosInstance.post('/referensi-finance/types', values);
                message.success('Berhasil dibuat');
            }
            setModalVisible(false);
            fetchData();
        } catch (err) {
            message.error('Gagal menyimpan data');
        }
    };

    const columns = [
        { title: 'ID', dataIndex: 'id_type_cost', width: 50, align: 'center' },
        { title: 'Nama Layanan/Biaya', width: '40%', dataIndex: 'type_cost_name', ellipsis: true },
        {
            title: 'Grup',
            dataIndex: 'cost_group_name',
            width: '30%', responsive: ['md'],
            render: (text) => text || <span style={{ color: 'gray' }}>-</span>
        },
        {
            title: 'Aksi',
            key: 'action',
            width: 100,
            align: 'center',
            fixed: 'right',
            render: (_, record) => (
                <Space size="small">
                    <Button icon={<EditOutlined />} size="small" onClick={() => handleEdit(record)} />
                    <Popconfirm title="Hapus layanan ini?" onConfirm={() => handleDelete(record.id_type_cost)}>
                        <Button icon={<DeleteOutlined />} size="small" danger />
                    </Popconfirm>
                </Space>
            )
        }
    ];

    return (
        <div>
            <div style={{ marginBottom: 12 }}>
                <Button type="primary" icon={<PlusOutlined />} size="small" onClick={handleAdd}>
                    Tambah Layanan
                </Button>
            </div>
            <Table
                dataSource={data}
                columns={columns}
                rowKey="id_type_cost"
                loading={loading}
                size="small"
                scroll={{ x: 400 }}
                pagination={{ pageSize: 10, size: "small" }}
            />
            <Modal
                title={editingId ? "Edit Layanan" : "Tambah Layanan"}
                open={modalVisible}
                onOk={handleOk}
                onCancel={() => setModalVisible(false)}
            >
                <Form form={form} layout="vertical">
                    <Form.Item
                        name="type_cost_name"
                        label="Nama Layanan"
                        rules={[{ required: true, message: 'Harap isi nama layanan' }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item name="id_cost_group" label="Grup Biaya">
                        <Select allowClear>
                            {groups.map(g => (
                                <Select.Option key={g.id_cost_group} value={g.id_cost_group}>
                                    {g.cost_group_name}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
};

export default CostTypeTable;
